import React from "react";
import parse from 'html-react-parser';
import ReactDOM from 'react-dom';
import QRCode from 'react-qr-code';

const AccordionContent = ({
  accordionData,
  activeAccordionId,
  accordionId,
  cssVariableValues,
  QR,
  calcHtmlElementNoWrapWidth
}) => {
  const isArpopup = accordionData.id === "arpopup";
  if (window.isMobIsipadIsPotrait || isArpopup) {
    return null;
  }
  // 🔥 For AR popup, always render (like submenu popups)
  // For other accordions, render only if active and has content
const shouldRender = isArpopup || accordionData.content;
  if (!shouldRender) return null;

  // ---------------------------
  // Popup style based on media
  // ---------------------------
  let listMedia = accordionData.media ? accordionData.media[0] : {};
  let desktopPopupLeft = 0;
  let desktopPopupTop = 0;
  let desktopPopupWidth = 0;
  let desktopPopupHeight = 0;

  if (Object.keys(listMedia).length !== 0) {
    const resolution = window.UiUtils.getResolution();
    desktopPopupLeft = listMedia[resolution]?.left || 0;
    desktopPopupTop = listMedia[resolution]?.top || 0;
    desktopPopupWidth = listMedia[resolution]?.width || 0;
    desktopPopupHeight = listMedia[resolution]?.height || 0;
  }

  const popupStyle = {
    left: `calc(0px + ${desktopPopupLeft})`,
    top: desktopPopupTop,
    width: desktopPopupWidth,
    height: desktopPopupHeight,
  };

  // ---------------------------
  // Render popup portal
  // ---------------------------
  return ReactDOM.createPortal(
    <div
      role="dialog"
      className={`popup ${
        isArpopup ? "qrcodeshow" : ""
      } ${accordionData.id === activeAccordionId ? "active" : ""}`} // Active class added
      id={accordionData.popupId || accordionId}
      data-id={accordionId}
      aria-modal="true"
      tabIndex={-1}
      style={popupStyle}
    >
      <h2>{parse(accordionData.popupHeading || accordionData.title)}</h2>
      <div className="content">
          {/* {isArpopup ? (
            <div className="qrContainer">
              <QRCode
                size={190}
                value={window.linkForGenerateQR}
                style={{ height: "auto" }}
                className="qrImage"
                aria-hidden="true"
              />
              <span
                className="text"
                data-contentwidth={calcHtmlElementNoWrapWidth(QR, cssVariableValues.qrTextFontSize)}
              >
                {QR || ""}
              </span>
            </div>
          ) : null} */}

          

        {Array.isArray(accordionData.content) ? (
          <ul>
            {accordionData.content.map((item, i) => (
              <li key={i}>{parse(item.text)}</li>
            ))}
          </ul>
        ) : (
          <p>{parse(accordionData.content)}</p>
        )}
      </div>
    </div>,
    document.getElementById("popupContainer")
  );
};

export default AccordionContent;
